import { render, staticRenderFns } from "./CorrespondenceDocuments.vue?vue&type=template&id=bbe5d6ca&scoped=true&"
import script from "./CorrespondenceDocuments.vue?vue&type=script&lang=js&"
export * from "./CorrespondenceDocuments.vue?vue&type=script&lang=js&"
import style0 from "./CorrespondenceDocuments.vue?vue&type=style&index=0&id=bbe5d6ca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe5d6ca",
  null
  
)

export default component.exports